<template>
  <div ref="input" class="input full" :class="{ full: input.full_width }">
    <transition name="fade">
      <div v-if="add_owner == 'resting'" @click="toggle('active')" class="add-owner">
        <img src="@/assets/img/add.svg" />
        <p>Add an Owner</p>
      </div>
    </transition>

    <transition name="fade">
      <div class="newOwner" v-if="add_owner == 'active'">
        <div class="input full">
          <label class="optionalPosition">
            Name
            <p class="optional" v-if="input.optional">(optional)</p>
          </label>

          <input ref="name" v-model="owner.name" id="ownerInput" />
        </div>

        <div class="input full">
          <label>Email</label>
          <input type="email" ref="email" v-model="owner.email" id="ownerInput" />
        </div>

        <div class="btn-group">
          <div class="input percentage-input">
            <label>Ownership %</label>
            <input
              ref="percentage"
              class="percentage"
              type="number"
              min="0"
              max="100"
              v-model="owner.percentage"
              id="ownerInput"
              @change="limitPercentage"
              pattern="\d*"
            />
            <span class="percent">%</span>
          </div>
        </div>
        <div class="btns">
          <button @click="validateOwner()" class="btn">Add OWner</button>
          <button @click="toggle('resting')" class="btn text-btn cancel">Cancel</button>
        </div>
        <p v-if="errors.length" class="errors">
          Please enter a
          <span
            v-for="(error, index) in errors"
          >{{ error }}{{ index + 1 == errors.length ? "." : ", " }}</span>
        </p>
      </div>
    </transition>

    <transition name="fade">
      <div class="owners" v-if="add_owner == 'resting'">
        <template v-if="owners.length">
          <div class="owner" v-for="(owner, i) in owners">
            <div @click="deleteOwner(i)" class="remove">x</div>
            <p>
              Name
              <span>{{ owner.name }}</span>
            </p>
            <p>
              Email
              <span>{{ owner.email }}</span>
            </p>
            <p>
              Percentage
              <span>{{ owner.percentage }}%</span>
            </p>
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ownershipDetails",
  props: ["input", "questionIndex", "answerKey"],
  data() {
    return {
      add_owner: "resting",
      owner: {
        name: null,
        email: null,
        percentage: null
      },
      answer: null,
      owners: [],
      errors: []
    };
  },
  mounted() {},
  created() {
    this.owners = this.input.value;
    this.owners == "" ? (this.owners = []) : "";
  },
  firestore() {
    return {};
  },
  methods: {
    toggle(step) {
      this.add_owner = null;
      setTimeout(() => {
        this.add_owner = step;
      }, 500);
    },
    limitPercentage(e) {
      if (parseInt(this.owner.percentage) > 100) {
        this.owner.percentage = 100;
      }

      if (parseInt(this.owner.percentage) < 0) {
        this.owner.percentage = 0.01;
      }
    },
    validateOwner() {
      let valid = true;
      this.errors = [];
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!this.owner.name) {
        valid = false;
        this.errors.push("valid Name");
        this.$refs.name.classList.add("error");
      } else {
        this.$refs.name.classList.remove("error");
      }

      if (this.owner.email) {
        if (!re.test(this.owner.email.toLowerCase())) {
          valid = false;
          this.errors.push("valid Email");
          this.$refs.email.classList.add("error");
        } else {
          this.$refs.email.classList.remove("error");
        }
      } else {
        valid = false;
        this.errors.push("valid Email");
        this.$refs.email.classList.add("error");
      }

      if (!this.owner.percentage) {
        valid = false;
        this.errors.push("valid Percentage");
        this.$refs.percentage.classList.add("error");
      } else {
        this.$refs.percentage.classList.remove("error");
      }

      if (valid) {
        this.toggle("resting");
        let owner = {
          name: this.owner.name,
          email: this.owner.email,
          percentage: this.owner.percentage
        };
        this.owners.push(owner);
        this.owner.name = null;
        this.owner.email = null;
        this.owner.percentage = null;
        this.saveAnswer();
      }
    },
    saveAnswer(e) {
      this.$emit(
        "updateAnswer",
        this.questionIndex,
        this.answerKey,
        this.owners
      );
    },
    deleteOwner(index) {
      this.owners.splice(index, 1);
    }
  },
  watch: {
    add_owner() {
      if (!this.add_owner || this.add_owner == "active") {
        this.$parent.show_btn = false;
      } else {
        this.$parent.show_btn = true;
      }
    }
  }
};
</script>

<style scoped lang="scss">
#firstRow {
  color: darkblue;
  font-weight: 500;
}
.text-btn {
  padding: 10px 0;
  text-decoration: underline;
  -ms-text-underline-position: under;
}

.errors {
  width: 100%;
  margin-top: 20px;
}

.percentage {
  max-width: 85px;
}

.btn-group {
  display: flex;
}
.percentage-input {
  position: relative;
  .percent {
    position: absolute;
    left: 63px;
    top: 35px;
    pointer-events: none;
  }
}

.owners {
  margin-top: 20px;
  margin-bottom: 20px;
  .owner {
    width: 100%;
    max-width: 400px;
    padding: 5px 20px;
    padding-top: 20px;
    margin-bottom: 10px;
    position: relative;
    background-color: white;
    background: white;
    box-shadow: 0px 2px lightgray;
    border: 2px solid transparent;
    p {
      color: #062035;
      margin: 0;
      font-size: 15px;
      padding: 8px 0;
      border-bottom: 1px solid #eaeaea;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      &:last-child {
        border-bottom: none;
      }
      span {
        opacity: 0.7;
        padding-left: 20px;
      }
    }
    .remove {
      position: absolute;
      right: 0;
      top: 0;
      background: #f44336;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 20px;
      width: 20px;
      color: white;
      cursor: pointer;
    }
  }
}

.add-owner {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: rgba(255, 255, 255, 1);
  padding: 30px 20px;
  cursor: pointer;
  border-bottom: 5px solid transparent;
  transition: border 0.5s;
  &:hover {
    border-bottom: 5px solid #0b6efb;
  }
  img {
    height: 30px;
  }
  p {
    color: #0b6efb;
    margin-bottom: 0;
    margin-top: 10px;
  }
}

.cancel {
  margin-left: 20px;
  font-size: 13px;
  text-decoration: none;
  color: #f44336;
}
</style>
